import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import PrivateLayout from 'components/Container/PrivateLayout';
import dayjs from 'dayjs';
import Maintenance from 'Pages/Maintenance';
import { PrintProvider } from 'Pages/PurchaseMade/ApprovedPayment/Ticket/context';
import { IS_IN_MAINTENANCE } from 'settings';

import AuthenticatedRoutes from './AuthenticatedRoutes';
import Gateway from './Gateway';

import 'dayjs/locale/pt-br';

const ValidateStartCheckin = React.lazy(() => import('Pages/Events/ValidateStartCheckin'));
const PurchaseMade = React.lazy(() => import('Pages/PurchaseMade'));
const CheckinPage = React.lazy(() => import('components/Pages/Admin/CheckinPage'));
const GiftTicket = React.lazy(() => import('components/Pages/Public/GiftTicket'));
const MarketPlace = React.lazy(() => import('components/Pages/Public/MarketPlace'));
const Shelf = React.lazy(() => import('components/Pages/Public/Shelf'));
const EventReview = React.lazy(() => import('components/Pages/Public/EventReview'));
const PreCheckout = React.lazy(() => import('components/Pages/Public/PreCheckout'));
const MyTickets = React.lazy(() => import('Pages/MyTickets'));
const MyTicketsDetail = React.lazy(() => import('Pages/MyTickets/Detail'));
const MyTicketsPrint = React.lazy(() => import('Pages/MyTickets/Detail/Print'));
const Participant = React.lazy(() => import('Pages/Participant'));
dayjs.locale('pt-br');

const Routes = () => {
  const renderMaintenance = () => {
    const isInMaintenance = IS_IN_MAINTENANCE === 'true';
    return isInMaintenance && <Route path='/' component={() => <Maintenance />} />;
  };

  return (
    <BrowserRouter getUserConfirmation={() => null}>
      <PrintProvider>
        <Switch>
          {renderMaintenance()}

          <Route path='/precheckout/:event_id/:transaction_key' exact component={PreCheckout} />
          <Route exact path='/participant/:ciphertext' component={Participant} />
          <Route exact path='/confirm/:hash' component={ValidateStartCheckin} />
          <Route exact path='/gift_ticket/:id' component={GiftTicket} />
          <Route exact path='/transfer/:id' component={GiftTicket} />
          <Route exact path='/obrigado_pela_compra' component={PurchaseMade} />
          <Route path='/marketplace' component={MarketPlace} />
          <Route path='/event-review/:id' component={EventReview} />
          <Route path='/shelf/:id' component={Shelf} />
          <Route path='/event/staff-checkin' component={CheckinPage} />
          <Route exact path='/my-tickets' component={MyTickets} />
          <Route exact path='/participant/print/:eventId' component={MyTicketsPrint} />
          <Route exact path='/participant/print/:eventId/:isGift/:attendanceId' component={MyTicketsPrint} />
          <Route exact path='/my-tickets/:eventId' component={MyTicketsDetail} />
          <PrivateLayout>
            <Gateway path='/' component={AuthenticatedRoutes} />
          </PrivateLayout>
          <Route render={() => <Redirect to='/' />} />
        </Switch>
      </PrintProvider>
    </BrowserRouter>
  );
};

export default Routes;
